class TermsAPI {

  static all(taxonomy) {
    let url = `/wp-json/wp/v2/${taxonomy}?orderby=slug&order=asc&per_page=99`

    return fetch(url, { 
      credentials: 'same-origin' 
    })
    .then(this.handleStatus)
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }

}

export default TermsAPI


// WEBPACK FOOTER //
// ./src/js/projects/api/TermsAPI.js